/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-use-before-define */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-filename-extension */
import React, { FC, Fragment } from 'react';
import { LISTING_GROUP_TREE_ROUTING } from '../../constant';

interface NameTemplateProps {
  campaignId: number;
  assetGroupId?: number;
  ariaLabel: string;
  name: string;
  scope: {
    append: Function,
    save: Function;
  };
}


export const NameTemplate: FC<NameTemplateProps> = (props) => {
  const {
    assetGroupId, ariaLabel, campaignId, name,
    scope,
  } = props;

  const onNavigateClick: React.MouseEventHandler<HTMLAnchorElement> = () => {
    scope.append({
      assetGroupId,
    });
    scope.save(LISTING_GROUP_TREE_ROUTING);
  };

  return (
    <Fragment>
      {name ?
        <a
          className="scope-navigator"
          onClick={onNavigateClick}
          href="javascript:void(0)"
          data-campaignid={campaignId}
          data-adgroupid={assetGroupId}
          aria-label={ariaLabel}
        >{name}
        </a>
        : ''}
    </Fragment>
  );
};
